import React from "react";
import "../host.css"

const HostInvoices = () => {
  return (
    <div
      className="container-fluid p-0"
      style={{ backgroundColor: "#f8f9fa", minHeight: "100%" }}
    >
      <div
        style={{
          minHeight: "500px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            fontSize: "24px",
            fontWeight: "bold",
            color: "#666",
            textAlign: "center",
            padding: "40px",
          }}
        >
          Yet to be developed
        </div>
      </div>
    </div>
  );
};

export default HostInvoices;